<template>
    <v-footer class="justify-space-between py-9 px-6 grey--text" id="footer_wrapper">
        <div>Copyright © {{copyright_year}} Succession Resource Group. All Rights Reserved.</div>
        <div class="text-center">
          <!-- LinkedIn -->
          <a :href="`https://www.linkedin.com/company/succession-resource-group`" target="_blank" title="LinkedIn" class="icon">
            <v-icon class="mr-4 grey--text">mdi-linkedin</v-icon>
          </a>
          <!-- Twitter -->
          <a :href="`https://twitter.com/SuccessionRG`" target="_blank" title="Twitter" class="icon">
            <v-icon class="mr-4 grey--text">mdi-twitter</v-icon>
          </a>
          <!-- Facebook -->
          <a :href="`https://www.facebook.com/SuccessionResourceGroup`" target="_blank" title="Facebook" class="icon">
            <v-icon class="mr-4 grey--text">mdi-facebook</v-icon>
          </a>
          <!-- Youtube -->
          <a :href="`https://www.youtube.com/channel/UCkdfW1-A9D_Fw26C0IFU20Q`" target="_blank" title="Youtube" class="icon">
            <v-icon class="mr-4 grey--text">mdi-youtube</v-icon>
          </a>
          <!-- Instagram -->
          <a :href="`https://www.instagram.com/successionresourcegroup`" target="_blank" title="Instagram" class="icon">
            <v-icon class="mr-4 grey--text">mdi-instagram</v-icon>
          </a>
        </div>
    </v-footer>
</template>

<script>

  export default {
    name: 'FooterContent',
    computed: {
      copyright_year() {
        return new Date().getFullYear().toString();
      }
    }
  }
</script>

<style>
  #footer_wrapper {
    width: 100%;
    background-color:#37383C;
  }
  a.icon {
    text-decoration: none;;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue